import { CoverPresenceModel, coverPresenceModelInitial } from './CoverPresenceModel';

export interface CoverPresenceBatchModel {
    coverPresence: CoverPresenceModel,
    classificationsId: number[]
}

export const coverPresenceBatchModelInitial: CoverPresenceBatchModel = {
    coverPresence: coverPresenceModelInitial,
    classificationsId: []
};